import { render, staticRenderFns } from "./customer-settings.vue?vue&type=template&id=f7e49174&scoped=true&"
import script from "./customer-settings.vue?vue&type=script&lang=js&"
export * from "./customer-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e49174",
  null
  
)

export default component.exports